import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { NotificationToastService } from 'src/app/services/notification-toast.service';
import { PdfService } from 'src/app/services/pdf.service';
import { ReportViewer } from 'src/app/model/report-viewer';
import { SafeResourceUrl } from '@angular/platform-browser';
import { ResizedEvent } from 'angular-resize-event';

@Component({
  selector: 'app-report-viewer-dialog',
  templateUrl: './report-viewer-dialog.component.html',
  styleUrls: ['./report-viewer-dialog.component.css']
})
export class ReportViewerDialogComponent implements OnInit {

  safeResourceUrl: SafeResourceUrl;
  loading: boolean;
  widthExp = 800;
  heightExp = 800;

  constructor(public dialogRef: MatDialogRef<ReportViewerDialogComponent>
    , private notificationToastService: NotificationToastService
    , private pdfService: PdfService
    , @Inject(MAT_DIALOG_DATA) public data: ReportViewer) {
  }

  async ngOnInit() {
    try {
      this.loading = true; 
       const pdfUrl = this.pdfService.base64ToPdfUrl(this.data.ReportBase64);
       this.safeResourceUrl = this.pdfService.pdfUrlToPdfSafeResourceUrl(pdfUrl); 
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Reporte');
    } finally {
      this.loading = false;
    }
  }

  getSafeResourceUrl(): SafeResourceUrl {
    return this.safeResourceUrl;
  }

  onNoClick(): void {
    this.dialogRef.close(null);
  }
  
  onResized(event: ResizedEvent): void {
    this.widthExp = event.newWidth;
    this.heightExp = event.newHeight;
  } 
}
